/**
 * MSAL Configuration for Microsoft Graph API
 *
 * Client/tenant come from VITE_MSAL_* build args in CI (see Dockerfile),
 * falling back to the MOREgroup registration for local dev.
 */

const CLIENT_ID = import.meta.env.VITE_MSAL_CLIENT_ID || 'ebc8517b-a9ab-465a-95fe-6b43b664abb7';
const TENANT_ID = import.meta.env.VITE_MSAL_TENANT_ID || '269f238f-b0fb-4ee1-be86-054b9b3fc1ec';

export const msalConfig = {
  auth: {
    clientId: CLIENT_ID,
    authority: `https://login.microsoftonline.com/${TENANT_ID}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'sessionStorage', // Use sessionStorage for iframe compatibility
    storeAuthStateInCookie: false,
  },
  system: {
    allowNativeBroker: false, // Disable native broker for iframe compatibility
    windowHashTimeout: 60000,
    iframeHashTimeout: 6000,
    loadFrameTimeout: 0,
  },
};

// loginRequest uses only User.Read so the sign-in popup never triggers the
// "Need admin approval" screen. Admin-required scopes are requested separately
// via silentRequest when fetching data, and the app handles consent errors gracefully.
export const loginRequest = {
  scopes: ['User.Read'],
};

export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
  graphUsersEndpoint: 'https://graph.microsoft.com/v1.0/users',
};

export const silentRequest = {
  scopes: ['User.Read', 'User.Read.All', 'Presence.Read.All'],
  forceRefresh: false,
};

// Scope for PeopleVUE's own API — tokens issued for this audience CAN be
// JWKS-verified by the function backend, unlike Graph-scoped tokens.
// Requires "Expose an API" to be configured in the app registration first.
export const apiScope = `api://${CLIENT_ID}/access_as_user`;
